import React, { useState, type FC } from "react";

import { useIntl } from "react-intl";
import { useRecoilValue } from "recoil";

import {
  Flex,
  SKELETON_LOADER_VARIANT_ONWHITE,
  SidePanel,
  SidePanelHeader,
  SkeletonLoader,
  TABBED_VARIANT_LIGHT,
  Tabbed,
} from "mailup-web-components";

//  import { panelEditRecipientCloseCallback } from 'Pages/RecipientsList/recoil/callbacks/recipient'
import { panelEditRecipientState } from "Pages/RecipientsList/recoil/state/recipient";

import BoxDynamicFields from "Pages/RecipientsList/components/aside/BoxDynamicFields";
import BoxFixedFields from "Pages/RecipientsList/components/aside/BoxFixedFields";
import PanelEditRecipientHeader from "Pages/RecipientsList/components/aside/PanelEditRecipientHeader";
import TabActivityStream from "Pages/RecipientsList/components/aside/TabActivityStream";
import TabGroups from "Pages/RecipientsList/components/aside/TabGroups";
import TabReceivingOptions from "Pages/RecipientsList/components/aside/TabReceivingOptions";
import TabTracking from "Pages/RecipientsList/components/aside/TabTracking";

const PanelEditRecipient: FC = () => {
  const intl = useIntl();
  const [y, setY] = useState(0);
  const { show, recipient, tracking } = useRecoilValue(panelEditRecipientState);

  //  const closePanel = useRecoilCallback(panelEditRecipientCloseCallback, [])

  const handleClickOutside = (): void => {
    //  void closePanel()
  };

  const handleScrollY = (y: number): void => {
    setY(y);
  };

  const tabs =
    recipient !== undefined
      ? [
          {
            id: "emailActivityStream",
            label: intl.formatMessage({
              id: "Load.RecipientsList.EmailActivityStream",
            }),
            content: <TabActivityStream item={recipient} channel="email" />,
          },
          {
            id: "smsActivityStream",
            label: intl.formatMessage({
              id: "Load.RecipientsList.SMSActivityStream",
            }),
            content: <TabActivityStream item={recipient} channel="sms" />,
          },
          {
            id: "dynamicFields",
            content: <BoxDynamicFields item={recipient} />,
            label: intl.formatMessage({
              id: "Load.RecipientsList.DynamicFields",
            }),
          },
          {
            id: "groups",
            content: <TabGroups item={recipient} />,
            label: intl.formatMessage({ id: "Load.RecipientsList.Groups" }),
          },

          {
            id: "tracking",
            label: intl.formatMessage({
              id: "Load.RecipientsList.TrackingTab",
            }),
            content: <TabTracking idRecipient={recipient.Id} />,
          },
          // {
          //   id: "receivingOptions",
          //   label: intl.formatMessage({
          //     id: "Load.RecipientsList.ReceivingOptions",
          //   }),
          //   content: (
          //     <TabReceivingOptions item={recipient} tracking={tracking} />
          //   ),
          // },
        ]
      : [];

  return (
    <SidePanel
      show={show}
      onClickOutside={handleClickOutside}
      width="740px"
      onContentScrollY={handleScrollY}
    >
      <SidePanelHeader padding="16px 32px" showBorder={y > 0}>
        <PanelEditRecipientHeader />
      </SidePanelHeader>

      <Flex flexDirection="column" gap="40px" padding="24px 32px">
        {recipient !== undefined && (
          <>
            <BoxFixedFields item={recipient} />
            <Tabbed tabs={tabs} variant={TABBED_VARIANT_LIGHT} />
          </>
        )}

        {recipient === undefined && (
          <>
            <SkeletonLoader
              height="28px"
              margin="0"
              variant={SKELETON_LOADER_VARIANT_ONWHITE}
            />
            <Flex flexDirection="column" gap="24px">
              <SkeletonLoader
                height="25px"
                margin="0"
                variant={SKELETON_LOADER_VARIANT_ONWHITE}
              />
              <SkeletonLoader
                height="25px"
                margin="0"
                variant={SKELETON_LOADER_VARIANT_ONWHITE}
              />
              <SkeletonLoader
                height="25px"
                margin="0"
                variant={SKELETON_LOADER_VARIANT_ONWHITE}
              />
            </Flex>
          </>
        )}
      </Flex>
    </SidePanel>
  );
};

export default PanelEditRecipient;
